export class LoadShiftsEvent {
    public static readonly type = '[JobsPlacements] Load shifts event';
}
